import React from "react";
import DoubleFilesIcon from "../../../assets/icons/double-files-purple-bg.svg";
import BlueBagIcon from "../../../assets/icons/blue-bag.svg";
import BluePenIcon from "../../../assets/icons/blue-pen-light-bg.svg";
import { useTranslation } from "react-i18next";
import ScriptAlreadySent from "../ScriptAlreadySent/ScriptAlreadySent";
import "./ScriptRow.less";

export type ScriptRowProps = {
  title: string;
  message: string;
  price?: number | null;
  category?: string;
  iconSrc?: string;
  onEdit?: () => void;
  onClick?: () => void;
  showSendButton?: boolean;
  onSend?: () => void;
  alreadySent?: boolean;
};

const ScriptRow: React.FC<ScriptRowProps> = ({
  title,
  message,
  price,
  iconSrc,
  onEdit,
  onClick,
  showSendButton = false,
  onSend,
  alreadySent = false,
}) => {
  const { t } = useTranslation();
  const isFree = !price || price <= 0;

  return (
    <div className="script-row" onClick={onClick} role="button" tabIndex={0}>
      <div className="script-row-left-icon">
        <img src={iconSrc || DoubleFilesIcon} alt="type" />
      </div>

      <div className="script-row-content">
        <div className="script-row-title" title={title}>
          <div className="script-row-title-warning-sent">
            {title}

            {showSendButton && alreadySent && <ScriptAlreadySent />}
          </div>
        </div>
        <div className="script-row-preview" title={message}>
          {message}
        </div>
      </div>

      <div className="script-row-price-zone" aria-label="price">
        <img className="script-row-bag" src={BlueBagIcon} alt="price" />
        <span className="script-row-price">{isFree ? t("free") : `${price!.toFixed(2)} €`}</span>
      </div>

      {showSendButton ? (
        <button
          type="button"
          className="script-row-send"
          onClick={(e) => {
            e.stopPropagation();
            onSend && onSend();
          }}
        >
          {t("send")}
        </button>
      ) : (
        <button
          type="button"
          className="script-row-edit"
          onClick={(e) => {
            e.stopPropagation();
            onEdit && onEdit();
          }}
          aria-label="edit"
        >
          <img src={BluePenIcon} alt="edit" />
        </button>
      )}
    </div>
  );
};

export default ScriptRow;
